import { BUILDING_TYPE_LABELS } from 'shared/constants/buildingLabels';
import type { IBuildingCard } from 'shared/types/buildingCard';

/** Текст ссылки на основное здание корпуса: «{тип} {название}» */
export function getParentLabel(card: IBuildingCard): string | null {
  if (!card.parent) {
    return null;
  }

  const typeLabel = card.parent.buildingType ? BUILDING_TYPE_LABELS[card.parent.buildingType] : undefined;

  return [typeLabel, card.parent.name].filter(Boolean).join(' ');
}
